import { render, staticRenderFns } from "./ItemClientCard.vue?vue&type=template&id=256835fd&scoped=true&lang=pug&"
import script from "./ItemClientCard.vue?vue&type=script&lang=js&"
export * from "./ItemClientCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemClientCard.vue?vue&type=style&index=0&id=256835fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256835fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
